import React, { useEffect, useRef, useState } from 'react';
import HtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';

import $ from 'jquery';

import ReCAPTCHA from 'react-google-recaptcha';
import { GlobalFormats } from '../../classes/main/globalFormats';

import {
    LoadingSection,
    awaitDelay, charactersRemainingGet, globalSettings, isUndNullEmp, languageObjGet, responseGet, sendMessageCloseCurrentWindowAsync, styles, validateEmail
} from '../../helpers/settings'
import Menu from '../main/Menu'
import axios from 'axios';

const currentMethod = 'Contact';

export default function Contact({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    const [formData, setFormData] = useState({});
    const [nameError, setNameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [subjectError, setSubjectError] = useState('');
    const [messageError, setMessageError] = useState('');
    const [recaptchaError, setRecaptchaError] = useState('');
    const charactersRemainingNumber = 400;
    const [charactersRemaining, setCharactersRemainig] = useState(``);
    const recaptchaRef = useRef('');
    const [showLoading, setShowLoading] = useState(true);
    const [showData, setShowData] = useState(false);

    const urlStop = '#nothing';
    const controls = {
        buttons: {
            send: {
                className: 'btn btn-outline-primary',
                id: 'btnSend',
            },
        },
        icons: {
            send: {
                id: 'iconSend',
                className: globalSettings?.icons?.paperPlane,
            },
        },
        inputs: {
            name: {
                id: 'inputName',
            },
            email: {
                id: 'inputEmail',
            },
            subject: {
                id: 'inputSubject',
            },
        },
        spinners: {
            send: {
                id: 'spSend',
                className: '',
            }
        },
        textAreas: {
            message: {
                id: 'inputMessage',
            },
        },
        urls: {
            // home: {
            //     id: 'urlhome',
            //     className: '',
            // },
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            reCaptchaPrivaciConditions: {
                id: 'urlReCaptchaPrivaciConditions',
                className: '',
            },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods
    const defaultValueSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            setFormData({
                email: '',
                name: '',
                message: '',
                subject: '',
                recaptchaToken: ''
            });
            recaptchaRef?.current?.reset();

            //setCharactersRemainig(`Caracteres restantes: <b>${charactersRemainingNumber}</b>`);
            setCharactersRemainig(charactersRemainingGet('', charactersRemainingNumber, `${globalSettings?.messages?.charactersRemaining?.[languageObj?.id]}:`, `Contact - ${currentMethod}`).result);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: {},
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errorDefaultValueSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errorDefaultValueSetAsync';
        let response = responseGet();
        try {
            // setFormDataErrors({
            //     email: '',
            //     name: '',
            //     message: '',
            //     subject: '',
            // });
            setNameError('');
            setEmailError('');
            setSubjectError('');
            setMessageError('');
            setRecaptchaError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: {},
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataSetAsync = async ({ property = '', value = '', object = 0, e = {}, subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            switch (object) {
                case 0:
                    setFormData({ ...formData, [property]: value, });
                    break;
                default:
                    //setFormDataErrors({ ...formDataErrors, [key]: value, })
                    break;
            }

            if (property === 'message') {
                //setCharactersRemainig(`Caracteres restantes: <b>${charactersRemainingNumber - e?.target?.value.length}</b>`);
                setCharactersRemainig(
                    charactersRemainingGet(
                        e?.target?.value,
                        charactersRemainingNumber,
                        `${globalSettings?.messages?.charactersRemaining?.[languageObj?.id]}:`,
                        `Contact - ${currentMethod}`
                    )?.result
                );
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: {},
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading(true);
            setShowData(true);

            //#region old code
            // response = defaultValueSetAsync();
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading(false);
            //     setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, null, false);
            //     return response;
            // }
            //#endregion old code

            response = await errorDefaultValueSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: {},
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            await awaitDelay({ delayTimer: globalSettings?.timers?.twoSeconds, });
            setShowLoading(false);
            setShowData(true);

            response = await defaultValueSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: {},
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }
        } catch (ex) {
            setShowLoading(false);
            setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: {},
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            response = await errorDefaultValueSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: {},
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            if (isUndNullEmp({ data: formData?.name, subMethod: currentMethod, })?.result) {
                setNameError(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: formData?.email, subMethod: currentMethod, })?.result) {
                setEmailError(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (!validateEmail({ email: formData.email })) {
                setEmailError(globalSettings?.messages?.youMustEnterValidEmail?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: formData?.subject, subMethod: currentMethod, })?.result) {
                setSubjectError(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: formData?.message, subMethod: currentMethod, })?.result) {
                setMessageError(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: formData?.recaptchaToken, subMethod: currentMethod, })?.result) {
                setRecaptchaError(globalSettings?.messages?.pleaseAcceptTheCaptcha?.[languageObj?.id]);
                response.isWarning = true;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: {},
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const infoSendAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'infoSendAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region check form data
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion check form data
            
            //sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');
            await controlsStatusSetAsync({ processType: 1, subMethod: currentMethod, });

            //#region Send message
            const dataObj = {
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlContactMessages}/${globalSettings?.app?.backend?.methods?.sendMessage}`,
                email: formData?.email,
                name: formData?.name,
                message: formData?.message,
                subject: formData?.subject,
                recaptchaToken: formData?.recaptchaToken,
            };

            const result = await axios?.post(
                dataObj?.url,
                formData,
            );
            const responseMessage = result.data;

            if (!responseMessage?.isSuccess || responseMessage?.isWarning) {
                await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });
                recaptchaRef?.current?.reset();
                await sendMessageCloseCurrentWindowAsync({
                    msgType: responseMessage?.msgType,
                    msgText: !isUndNullEmp({ data: responseMessage?.msgHtml, subMethod: currentMethod, })?.result ? responseMessage?.msgHtml : responseMessage?.msgText,
                    closeWindow: false,
                    urlGoTo: responseMessage?.urlGoTo,
                    auth: {},
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const responseTwo = await defaultValueSetAsync({ subMethod: currentMethod, });
            if (!responseTwo?.isSuccess || responseTwo?.isWarning) {
                return responseTwo;
            }
            //#endregion Send message

            //sendMessage(0, response.msgText, 0, true, false, null, '');
            await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });
            await sendMessageCloseCurrentWindowAsync({
                msgType: responseMessage?.msgType,
                msgText: !isUndNullEmp({ data: responseMessage?.msgHtml, subMethod: currentMethod, })?.result ? responseMessage?.msgHtml : responseMessage?.msgText,
                closeWindow: false,
                urlGoTo: responseMessage?.urlGoTo,
                auth: {},
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: {},
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const recaptchaOnchengeAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'recaptchaOnchengeAsync';
        let response = responseGet();
        try {
            //formDataSetAsync('recaptchaToken', recaptchaRef.current.getValue(), 0);
            await formDataSetAsync({ property: 'recaptchaToken', value: recaptchaRef?.current?.getValue(), object: 0, e: e, subMethod: currentMethod, });
            setRecaptchaError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: {},
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSetAsync = async ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.send?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.send?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.send?.id}`)?.removeClass();

                    $(`#${controls?.icons?.send?.id}`)?.addClass(controls?.icons?.send?.className);
                    $(`#${controls?.buttons?.send?.id}`)?.addClass(controls?.buttons?.send?.className);
                    $(`#${controls?.spinners?.send?.id}`)?.addClass(controls?.spinners?.send?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.send?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.send.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            $(`#${controls?.inputs?.name?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.subject?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.textAreas?.message?.id}`).attr('readOnly', (processType !== 0));

            $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
                'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
                'target': (processType !== 0 ? '' : '_blank'),
            });

            if (processType !== 0) {
                $(`#${controls?.buttons?.send?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: {},
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            console.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'onLoad - from' });
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName={'home'} process={'contact'} />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.contact?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    {/* <li className='breadcrumb-item'><a href='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</a></li> */}
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.contact?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                <section className='content'>
                    <div className='container-fluid'>

                        {/* {!showLoading ?
                            <div> */}
                        {showData ?
                            <div className='row'>
                                <section className='col-lg-6 connectedSortable'>

                                    <div className='card card-widget widget-user shadow-lg'>
                                        <div className='widget-user-header text-white' style={{ background: `url('${globalSettings?.images?.buildings001}')` }}>
                                            <h3 className='widget-user-username text-right'>{globalSettings?.app?.name}</h3>
                                            <h6 className='widget-user-desc text-right'>{globalSettings?.messages?.theOnlyAndBestProgramInCondominiumManagement?.[languageObj?.id]}</h6>
                                        </div>

                                        <div className='widget-user-image'>
                                            <img className='img-circle elevation-2' src={globalSettings?.images?.appLogo} alt='AppLogo' />
                                        </div>

                                        <div className='card-body'>
                                            <br />
                                            <div className='row'>
                                                <div className='text-center d-flex align-items-center justify-content-center'>
                                                    <div>
                                                        <p className='lead mb-5'>{globalSettings?.app?.address}<br />
                                                            {globalSettings?.labels?.zipCode?.[languageObj?.id]}: {globalSettings?.app?.zipCode}
                                                        </p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card shadow-lg'>
                                        <LoadingSection alt='loadingSection'
                                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                            height={20}
                                            hidden={!showLoading}
                                            width={20}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />
                                        <div className='card-body'>
                                            <div className='row'>
                                                <div className='text-center d-flex align-items-center justify-content-center'>
                                                    <iframe width={750}
                                                        height={500}
                                                        src={globalSettings?.app?.urlGoogleMaps}
                                                        frameBorder={0}
                                                        scrolling='no'
                                                        title='GoogleMap: Vzla Condominios'
                                                        marginHeight={0}
                                                        marginWidth={0} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </section>

                                <section className='col-lg-6 connectedSortable'>

                                    <div className='card shadow-lg'>
                                        <LoadingSection alt='loadingSection'
                                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                            height={20}
                                            hidden={!showLoading}
                                            width={20}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        <div className='card-body'>
                                            <form onSubmit={(e) => infoSendAsync({ e: e, subMethod: e?.currentTarget?.id, })}>

                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input id={controls?.inputs?.name?.id}
                                                            className='form-control'
                                                            maxLength={60}
                                                            placeholder={globalSettings?.labels?.name?.[languageObj?.id]}
                                                            //autoFocus
                                                            onChange={(e) => formDataSetAsync({ property: 'name', value: e?.target?.value, object: 0, e: e, subMethod: e?.currentTarget?.id, })}
                                                            onFocus={() => setNameError('')}
                                                            value={!isUndNullEmp({ data: formData?.name, subMethod: currentMethod })?.result ? formData?.name : ''}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.name?.[languageObj?.id]} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={globalSettings?.icons?.user} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(nameError)}</div>
                                                </div>

                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input id={controls?.inputs?.email?.id}
                                                            className='form-control'
                                                            maxLength={60}
                                                            placeholder={globalSettings?.labels?.email?.[languageObj?.id]}
                                                            onChange={(e) => formDataSetAsync({ property: 'email', value: e?.target?.value, object: 0, e: e, subMethod: e?.currentTarget?.id, })}
                                                            onFocus={() => setEmailError('')}
                                                            value={!isUndNullEmp({ data: formData?.email, subMethod: currentMethod })?.result ? formData?.email : ''}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.email?.[languageObj?.id]}
                                                            type='email' />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={globalSettings?.icons?.envelope} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(emailError)}</div>
                                                </div>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input id={controls?.inputs?.subject?.id}
                                                            className='form-control'
                                                            maxLength={60}
                                                            placeholder={globalSettings?.labels?.subject?.[languageObj?.id]}
                                                            onChange={(e) => formDataSetAsync({ property: 'subject', value: e?.target?.value, object: 0, e: e, subMethod: e?.currentTarget?.id, })}
                                                            onFocus={() => setSubjectError('')}
                                                            value={!isUndNullEmp({ data: formData?.subject, subMethod: currentMethod })?.result ? formData?.subject : ''}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.subject?.[languageObj?.id]} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={globalSettings?.icons?.envelope} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(subjectError)}</div>
                                                </div>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <textarea id={controls?.textAreas?.message?.id}
                                                            className='form-control'
                                                            maxLength={charactersRemainingNumber}
                                                            placeholder={globalSettings?.labels?.message?.[languageObj?.id]}
                                                            onChange={(e) => formDataSetAsync({ property: 'message', value: e?.target?.value, object: 0, e: e, subMethod: e?.currentTarget?.id, })}
                                                            onFocus={() => setMessageError('')}
                                                            rows={3}
                                                            value={!isUndNullEmp({ data: formData?.message, subMethod: currentMethod })?.result ? formData?.message : ''}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.message?.[languageObj?.id]} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={globalSettings?.icons?.edit} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='form-text' style={styles.labelMsgInfo}>{HtmlParser(charactersRemaining)}</div>
                                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(messageError)}</div>
                                                </div>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <ReCAPTCHA className='text-center'
                                                            //lang='es-419'
                                                            //hl='es-419'
                                                            hl={languageObj?.recaptchat?.languageCode}
                                                            onChange={(e) => recaptchaOnchengeAsync({ e: e, subMethod: e?.currentTarget?.id, })}
                                                            ref={recaptchaRef}
                                                            sitekey={globalSettings?.app?.reCAPTCHA?.reCaptchaV2SiteKey}
                                                            size='normal' />
                                                    </div>
                                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(recaptchaError)}</div>
                                                </div>
                                                <div className='form-group'>
                                                    <div className='text-right'>
                                                        <button id={controls?.buttons?.send?.id}
                                                            type='submit'
                                                            className={controls?.buttons?.send?.className}
                                                            title={`${globalSettings?.labels?.send?.[languageObj?.id]}`}
                                                            tooltip='tooltip' >
                                                            <i id={controls?.icons?.send?.id} className={controls?.icons?.send?.className} /> <span id={controls?.spinners?.send?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                    <div className='text-muted text-center text-small'>
                                        <p>
                                            <small>{globalSettings?.labels?.protectedByReCAPTCHA?.[languageObj?.id]} - <a id={controls?.urls?.reCaptchaPrivaciConditions?.id} target='_blank' href={globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions} rel='noreferrer'>{globalSettings?.labels?.privacyAndConditions?.[languageObj?.id]}</a></small>
                                        </p>
                                    </div>
                                </section>
                            </div>
                            :
                            <div></div>
                        }

                        {/* </div>
                            :
                            <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                width={40}
                                height={40}
                                color={globalSettings?.colors?.infoColorExp}
                                msgText={globalSettings?.messages?.processing?.[languageObj?.id]}
                                msgOrientation='text-center'
                                msgTextMuted={true} />
                        } */}
                    </div>
                </section>

            </div>
        </div>
    )
}